module.exports = __webpack_public_path__ + "static/media/01.28e38fa3.webp";